import { mainnet, sepolia, polygon } from 'wagmi/chains';
import { http, createConfig } from 'wagmi';

// Define Hoodi testnet chain with correct RPC endpoint
const hoodiTestnet = {
  id: 560048, // Chain ID from the RPC endpoint
  name: 'Hoodi Testnet',
  network: 'hoodi-testnet',
  nativeCurrency: {
    decimals: 18,
    name: 'ETH',
    symbol: 'ETH',
  },
  rpcUrls: {
    public: { http: ['https://rpc.hoodi.ethpandaops.io'] },
    default: { http: ['https://rpc.hoodi.ethpandaops.io'] },
  },
  blockExplorers: {
    default: { name: 'Hoodi Explorer', url: 'https://rpc.hoodi.ethpandaops.io' },
  },
} as const;

const chains = [hoodiTestnet, sepolia, mainnet, polygon] as const;

export const wagmiConfig = createConfig({
  chains,
  transports: {
    [hoodiTestnet.id]: http('https://rpc.hoodi.ethpandaops.io'),
    [sepolia.id]: http(),
    [mainnet.id]: http(),
    [polygon.id]: http(),
  },
});

export { chains }; 